import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import AntButton from 'antd/lib/button';
import colorShape from '../shapes/colorShape';

import './style';

const propTypes = {
  ...AntButton.propTypes,
  type: PropTypes.oneOf(['primary', 'default', 'dashed']),
  /**
   * Fit the width to the text of the button
   */
  fitText: PropTypes.bool,
  /**
   * Set button to disabled
   */
  disabled: PropTypes.bool,
  /**
   * Remove border and spacing of the button
   */
  ghost: PropTypes.bool,
  size: PropTypes.oneOf(['large', 'small', 'default']),
  shape: PropTypes.string,
  /**
   * custom classes
   */
  color: colorShape,
};

const defaultProps = {
  type: 'default',
  fitText: false,
  size: 'default',
  color: 'scouting-blue',
  disabled: false,
  ghost: false,
  shape: undefined,
};

const CLASSNAME = 'bsa-button';

/**
 * Button component for bsa
 */
function Button(props) {
  const {
    children, fitText, type, size, color, disabled,
    className: userClassName, shape, ghost, ...rest
  } = props;

  const className = classNames(
    CLASSNAME,
    userClassName,
    `${CLASSNAME}--type-${type}`,
    {
      [`${CLASSNAME}--size-${size}`]: !fitText && !shape,
      [`${CLASSNAME}--color-${color}`]: !disabled,
      [`${CLASSNAME}--ghost`]: ghost,
    },
  );

  return (
    <AntButton
      className={className}
      size={size}
      type={type}
      disabled={disabled}
      ghost={ghost}
      shape={shape}
      {...rest}
    >
      {children}
    </AntButton>
  );
}

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;
Button.Group = AntButton.Group;
export default Button;
